module.exports = __webpack_public_path__ + "img/pin_exchange_orange.f5073037.svg";